import { Component } from '@angular/core';
import { SharedPeerToPeerSuccessComponent } from '@pages/send-money/components/peer-to-peer-success/shared-peer-to-peer-success.component';
import { SharedPeerToPeerSuccessModule } from '@pages/send-money/components/peer-to-peer-success/shared-peer-to-peer-success.module';

@Component({
    standalone: true,
    selector: 'app-customer-success-cash-in',
    templateUrl: './peer-to-peer-success.component.html',
    styleUrls: ['./peer-to-peer-success.component.scss'],
    imports: [SharedPeerToPeerSuccessModule],
})
export class PeerToPeerSuccessComponent extends SharedPeerToPeerSuccessComponent {}
